var map = {
  "./en/resource.json": [
    "77394",
    [
      807
    ]
  ],
  "./es/resource.json": [
    "25567",
    [
      788
    ]
  ],
  "./ja/resource.json": [
    "12412",
    []
  ],
  "./zh_cn/resource.json": [
    "39129",
    [
      122
    ]
  ],
  "./zh_tw/resource.json": [
    "13249",
    [
      170
    ]
  ],
  "./ko/resource.json": [
    "91065",
    [
      789
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids[1].map(function(chunkId) { return __webpack_require__.e(chunkId); })).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 82388;
module.exports = __rspack_async_context;
